import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

class DateTimeModal extends Component {
  constructor(props) {
    super(props);
    this.currentTime = moment();
    this.choosenTime = !props.start ? moment().subtract(2, 'hours') : moment(props.start, "MMM DD, YYYY, hh:mm A") ;
    this.selectHours = [12, ...Array.from({ length: 11 }, (_, i) => i + 1)];
    this.selectMinutes = Array.from({ length: 60 }, (_, i) => i);
    this.selectDayInterval = ['AM', 'PM'];
    const start = this.choosenTime.format("MMM DD, YYYY, hh:mm A");
    this.state = {
      startDate: this.choosenTime.toDate(),
      fields: {
        choosenStartHour: this.choosenTime.format('hh'),
        choosenStartMinute: this.choosenTime.format('mm'),
        choosenStartDayInterval: this.choosenTime.format('A')
      },
      start,
      errors: {},
      filteredHours: this.selectHours,
      filteredMinutes: this.selectMinutes,
    };
  }

  componentDidMount() {
    this.updateOptions();
    if(document.querySelector("select[name='choosenStartHour']")){
        document.querySelector("select[name='choosenStartHour']").focus();
    }
  }

  updateOptions = () => {
    this.updateHourOptions(() => {
        this.updateMinuteOptions();
    });
  };

  handleDateChange = (date) => {
    this.setState({
      startDate: date,
      fields: {
        ...this.state.fields,
        startDate: date
      }
    }, () => {
      this.updateDateTimeFields(date);
    });
  };

  handleChange = (e) => {
    this.updateDateTimeFields(this.state.fields.startDate, e.target.name, e.target.value);
  }

  updateDateTimeFields = (date, name, value) => {
    let fields = { ...this.state.fields };
    fields[name] = value;
    this.setState({
      fields
    }, () => {
      this.updateOptions();
    });
  };

  updateHourOptions = (callback) => {
    const { startDate, fields: { choosenStartDayInterval, choosenStartHour } } = this.state;
    let filteredHours = this.selectHours;
    let newChoosenStartHour = choosenStartHour;
    if (moment(startDate).isSame(new Date(), 'day')) {
      filteredHours = this.selectHours.filter(hour => {
        const fullTime = `${hour} ${choosenStartDayInterval}`;
        return moment(fullTime, 'h A').isBefore(this.currentTime);
      });
  
      if (!filteredHours.includes(parseInt(choosenStartHour, 10))) {
        newChoosenStartHour = String(filteredHours[0]).padStart(2, '0');
      }
    }
    this.setState({
      fields: { ...this.state.fields, choosenStartHour: newChoosenStartHour },
      filteredHours: filteredHours
    }, () => callback ? callback() : false);
  };

  updateMinuteOptions = () => {
    const { fields: { choosenStartHour, choosenStartMinute, choosenStartDayInterval }, startDate } = this.state;
    const currentHour = this.currentTime.format('h');
    const currentMinute = this.currentTime.format('mm');
    const currentDayInterval = this.currentTime.format('A');
  
    let filteredMinutes = this.selectMinutes;
    let newChoosenStartMinute = choosenStartMinute;
  
    if (
      moment(startDate).isSame(new Date(), 'day') &&
      parseInt(choosenStartHour, 10) === parseInt(currentHour, 10) &&
      choosenStartDayInterval === currentDayInterval
    ) {
      filteredMinutes = this.selectMinutes.filter((minute) => minute <= currentMinute);
  
      if (!filteredMinutes.includes(parseInt(choosenStartMinute, 10))) {
        newChoosenStartMinute = String(filteredMinutes[0]).padStart(2, '0');
      }
    }
  
    this.setState({
      fields: { ...this.state.fields, choosenStartMinute: newChoosenStartMinute },
      filteredMinutes
    });
  };
  
  

  renderSelect = (name, value, options, suffix) => (
    <select name={name} value={value} onChange={this.handleChange}>
      {options.map((option) => (
        <option key={option} value={String(option).padStart(2, '0')}>
          {String(option).padStart(2, '0') + suffix}
        </option>
      ))}
    </select>
  );

  handleSubmit = () => {
    const { startDate, fields: { choosenStartHour, choosenStartMinute, choosenStartDayInterval } } = this.state;
    const selectedTime = `${choosenStartHour}:${choosenStartMinute} ${choosenStartDayInterval}`;
    const formattedDate = moment(startDate).format('MMM DD, YYYY');
    const start = `${formattedDate}, ${selectedTime}`;
    this.props.submit({ booking_start_time_str: start }, true);
  }
  

  render() {
    const { startDate, fields, filteredHours, filteredMinutes } = this.state;

    return (
      <div>
        <div className="datepicker-modal-overlay">
          <div className="datepicker-modal-content">
            <span onClick={() => this.props.close(false, !this.props.start ? true : false)} className="datepicker-modal-close">&times;</span>
            <p style={{ textAlign: 'left' }}>We aren't sure of your entry time. Please select the correct entry time to avoid any additional parking charges.</p>
            <div>
              <DatePicker
                selected={startDate}
                onChange={this.handleDateChange}
                maxDate={new Date()}
                inline
              />
              <div>
                <h6>Select Time</h6>
                <div className="pay-duration">
                  <span>{this.renderSelect('choosenStartHour', fields.choosenStartHour, filteredHours, '')}</span>
                  <span>{this.renderSelect('choosenStartMinute', fields.choosenStartMinute, filteredMinutes, '')}</span>
                  <span>{this.renderSelect('choosenStartDayInterval', fields.choosenStartDayInterval, this.selectDayInterval, '')}</span>
                  <div style={{ clear: 'both' }}></div>
                </div>
                <div className="error-msg">{this.state.errors['startTime']}</div>
              </div>
            </div>
            <div>
                <button className='date-time-btn' onClick={this.handleSubmit}>{this.props.start ? "Update" : "Save"}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DateTimeModal;
